import { render, staticRenderFns } from "./instructionCategoryTable.vue?vue&type=template&id=f1fc2244"
import script from "./instructionCategoryTable.vue?vue&type=script&lang=js"
export * from "./instructionCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports